(() => {
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.shy-mobile-menu[open]');
    if (open) { open.open = false; open.querySelector('summary')?.focus(); }
  });

  document.addEventListener('click', event => {
    const open = document.querySelector('.shy-mobile-menu[open]');
    if (open && !open.contains(event.target)) open.open = false;
  });

  document.querySelectorAll('.shr__facts > div').forEach(fact => {
    const label = fact.querySelector('dt');
    const detail = fact.querySelector('dd');
    if (label?.textContent.trim() === 'In the studio' && detail) {
      detail.textContent = 'Sonos, movable furniture and two private rooms that can be used for changing or breakout space.';
    }
  });

  const swapImg = (selector, src, alt) => {
    const img = document.querySelector(selector);
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    img.alt = alt;
  };

  if (location.pathname === '/pages/about') {
    swapImg('#about-intro .home-edit-item img',
      'https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-treatment-floor-studio.jpg?v=1789155641&width=1600',
      'Treatment floor and studio interior at SHY in Lewes');
    swapImg('#studio-life .home-edit-item:nth-child(2) img',
      'https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-hire-high-street-studio-interior-2026.jpg?v=1789423660&width=1600',
      "SHY's reception and High Street windows with wooden furniture and hanging paper lights");
    swapImg('#corporate-gifting .home-edit-item:first-child img',
      'https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-semi-permanence-artwave-2026.jpg?v=1789412855&width=1600',
      'Guests at the SEMI-PERMANENCE exhibition opening at SHY');
    document.querySelectorAll('a[href=\"/pages/whats-on\"]').forEach(link => {
      if (link.textContent.toLowerCase().includes('happening')) link.textContent = 'what’s on';
    });
  }

  /* Shop stays product-led. Jewellery fitting is a piercing service, not a shop category. */
  document.querySelectorAll('.shy-nav-group--shop a, .shy-mobile-panel a').forEach(link => {
    const href = link.getAttribute('href') || '';
    const label = link.textContent.trim().toLowerCase();
    if (href === '/pages/treatments/jewellery-styling-fitting' || label.includes('jewellery styling + fitting')) link.remove();
  });

  if (location.pathname === '/pages/shop-shy') {
    swapImg('.shy-photo-hero__media img',
      'https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-shop-high-street-retail-window-2026.jpg?v=1789459447&width=1600',
      'Retail shelves, plants and High Street windows inside SHY in Lewes');
    document.querySelectorAll('p').forEach(p => {
      if (p.textContent.includes('jewellery sizing and fittings available by appointment')) {
        p.textContent = 'The studio carries a wider edit of jewellery, gifts and small finds. Come in Tuesday to Saturday, 10am–5pm, to see what’s on the shelves.';
      }
    });
  }

  /* Hire is approved: only replace the curtain-room photograph with the supplied event canapés. */
  if (location.pathname === '/pages/hire-shy') {
    swapImg('.shr__photos figure:nth-child(2) img',
      'https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-hire-canapes.jpg?v=1789470096&width=1200',
      'Canapés served at a SHY event in Lewes');
  }

  /* FAQs: one clean introduction, then the library. Keep the final contact panel light. */
  if (location.pathname.includes('faq')) {
    document.documentElement.classList.add('shy-faq-final');
    document.querySelectorAll('p').forEach(p => {
      if (p.textContent.includes('without filling every service page with another chapter')) p.remove();
    });
    document.querySelectorAll('section').forEach(section => {
      const heading = section.querySelector('h1,h2,h3');
      if (heading?.textContent.trim() === 'Still have a question?') section.classList.add('shy-faq-contact-final');
    });
  }

  /* Bridal: positive, simple language and a tighter page rhythm. */
  document.querySelectorAll('.sbd--extras h2').forEach(heading => {
    if (heading.textContent.includes('More of SHY')) heading.textContent = 'More at SHY.';
  });
  document.querySelectorAll('.sbd__extras-head > p').forEach(p => {
    if (p.textContent.includes('fixed package') || p.textContent.includes('if it fits')) {
      p.textContent = 'Facials, lashes, brows, nails, piercing, jewellery and Gift Cards are all available at the studio in the run-up to the day.';
    }
  });
  if (document.querySelector('.sbd')) document.documentElement.classList.add('shy-bridal-final');

  /* Footer: smaller, lighter and more like the studio than a large olive end-card. */
  const footer = document.querySelector('.shy-footer');
  if (footer) {
    const logo = footer.querySelector('.night-footer-logo');
    if (logo?.src.includes('shy-logo-white.svg')) logo.src = logo.src.replace('shy-logo-white.svg','shy-logo-black.svg');
    const top = footer.querySelector('.night-footer-top');
    if (top && !top.querySelector('.shy-footer-photo')) {
      const figure = document.createElement('figure');
      figure.className = 'shy-footer-photo';
      figure.innerHTML = '<img src=\"https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-shop-high-street-retail-window-2026.jpg?v=1789459447&width=500\" width=\"360\" height=\"480\" loading=\"lazy\" alt=\"Inside SHY on Lewes High Street\">';
      top.prepend(figure);
    }
  }

  document.querySelectorAll('.shy-events__empty p').forEach(p => {
    if (p.textContent.includes('other things happening at SHY')) p.textContent = 'Exhibitions, workshops and events at SHY.';
  });

  const polish = document.createElement('style');
  polish.textContent = `
    .shy-header .shy-mega{background:#F2EFE5!important;border-color:rgba(65,71,38,.24)!important;border-top:4px solid var(--shy-yellow)!important;box-shadow:0 18px 34px rgba(36,39,32,.15)!important;padding-top:18px!important}
    .shy-header .shy-mega__column+.shy-mega__column{border-left:1px solid rgba(65,71,38,.17);padding-left:clamp(18px,2.4vw,30px)}
    .shy-header .shy-mega__heading{color:var(--shy-olive)!important;font-weight:600!important;letter-spacing:.075em!important;margin-bottom:10px!important}
    .shy-header .shy-mega__link:hover{text-decoration-color:var(--shy-yellow)!important;text-decoration-thickness:3px!important}
    .shy-header .shy-mega__person{border-bottom-color:rgba(65,71,38,.16)!important}
    .shy-header .shy-mega__person small{color:#656A54!important}
    .shy-header .shy-mobile-panel{background:#F2EFE5!important;border-top:4px solid var(--shy-yellow)!important}

    .shy-events-page:not(.shy-events-page--compact) .shy-event-card .shy-media{aspect-ratio:4/5!important;height:auto!important;object-fit:contain!important;object-position:center!important;background:var(--shy-paper)!important}
    .shy-events-page:not(.shy-events-page--compact) .shy-event-card__plate{aspect-ratio:4/5!important}


    html.shy-faq-final main{--shy-faq-width:980px}
    html.shy-faq-final main > .shopify-section{max-width:var(--shy-faq-width);margin-inline:auto}
    html.shy-faq-final .collapsible-content{padding-top:0!important;padding-bottom:0!important}
    html.shy-faq-final .collapsible-content__heading{font-size:clamp(27px,3vw,38px)!important;line-height:1.05!important;margin-bottom:14px!important}
    html.shy-faq-final .accordion summary{min-height:52px!important}
    html.shy-faq-final .accordion__title{font-size:15px!important;line-height:1.35!important}
    html.shy-faq-final .shy-faq-contact-final{background:var(--shy-paper)!important;color:var(--shy-ink)!important;border-top:3px solid var(--shy-yellow)!important;margin-top:34px!important}
    html.shy-faq-final .shy-faq-contact-final :is(h1,h2,h3,p,a){color:var(--shy-ink)!important}

    html.shy-bridal-final .sbd .shy-wrap{max-width:1100px!important}
    html.shy-bridal-final .sbd__olive figure{width:min(100%,360px)!important;justify-self:center!important}
    html.shy-bridal-final .sbd__extras-links{gap:10px!important;border-top:0!important}
    html.shy-bridal-final .sbd__extras-links a{background:var(--shy-wash)!important;border:0!important;border-radius:8px!important;padding:14px!important}

    .shy-footer{background:var(--shy-paper)!important;color:var(--shy-ink)!important;border-top:1px solid var(--shy-rule)!important;padding:28px 0 14px!important}
    .shy-footer .night-footer-top{display:grid!important;grid-template-columns:110px minmax(0,1fr) auto!important;align-items:center!important;gap:20px!important;padding-bottom:22px!important}
    .shy-footer-photo{margin:0!important;width:110px;height:84px;border-radius:8px;overflow:hidden;background:var(--shy-wash)}
    .shy-footer-photo img{display:block;width:100%;height:100%;object-fit:cover}
    .shy-footer .night-footer-top>p{font-size:clamp(24px,3vw,34px)!important;line-height:1.02!important;max-width:18ch!important;color:var(--shy-ink)!important}
    .shy-footer .night-footer-visit{color:var(--shy-ink)!important;font-size:12px!important}
    .shy-footer .night-footer-columns{grid-template-columns:1.2fr repeat(4,minmax(0,1fr))!important;gap:18px 26px!important;padding:20px 0 22px!important;border-top:1px solid var(--shy-rule)!important}
    .shy-footer .night-footer-column h2{color:var(--shy-olive)!important;margin-bottom:9px!important}
    .shy-footer .night-footer-column :is(p,a){color:var(--shy-ink)!important;font-size:13px!important;line-height:1.45!important}
    .shy-footer .night-footer-logo{width:110px!important;opacity:1!important;margin:0 0 16px!important;filter:none!important}
    .shy-footer .shy-footer__bottom{border-top:1px solid var(--shy-rule)!important;color:var(--shy-meta)!important;padding-top:14px!important}
    .shy-footer .shy-footer__bottom a{color:var(--shy-ink)!important}

    @media(max-width:989px),(hover:none){
      .shy-header .shy-mega__column+.shy-mega__column{border-left:0;padding-left:0}
      .shy-footer .night-footer-top{grid-template-columns:84px minmax(0,1fr)!important}
      .shy-footer .night-footer-visit{grid-column:1/-1!important}
      .shy-footer-photo{width:84px;height:72px}
      .shy-footer .night-footer-columns{grid-template-columns:repeat(2,minmax(0,1fr))!important}
      .shy-footer .night-footer-column:first-child{grid-column:1/-1!important}
    }
    @media(max-width:749px){
      html.shy-bridal-final .sbd__olive figure{width:min(78%,260px)!important;justify-self:center!important}
    }
  `;
  document.head.appendChild(polish);
})();
